import moment from 'moment';
import { IFabricationProject } from '../../../../../store/ducks/fabrication-projects/types';

export const useOnFilter = () => {
  const handleFilterByMockup = (
    selectedMockup: string,
    filteredProjects: IFabricationProject[]
  ) => {
    return filteredProjects.filter((project) => {
      return project.mockupName === selectedMockup;
    });
  };

  const handleFilterByStructure = (
    selectedStructure: string,
    filteredProjects: IFabricationProject[]
  ) => {
    return filteredProjects.filter((project) =>
      project.structures.some((st) => st.name === selectedStructure)
    );
  };

  const handleFilterByStatusOfRevision = (
    selectedStatusOfRevision: string,
    filteredProjects: IFabricationProject[]
  ) => {
    return filteredProjects.filter((project) => {
      return project.revisionStatus === selectedStatusOfRevision;
    });
  };

  const handleFilterBySearchInput = (
    searchInputValue: string,
    projects: IFabricationProject[]
  ) => {
    return projects.filter((project) => {
      return (
        project.fileName.toUpperCase().includes(searchInputValue) ||
        project.mockupName?.toUpperCase().includes(searchInputValue) ||
        project.contractNumber.includes(searchInputValue) ||
        moment(project.creationDate, 'YYYY-MM-DD')
          .format('DD/MM/YYYY')
          .includes(searchInputValue) ||
        project.structures.some((structure) =>
          structure.name.toUpperCase().includes(searchInputValue)
        ) ||
        project.revisionStatus?.toUpperCase().includes(searchInputValue) ||
        project.revision?.toUpperCase().includes(searchInputValue)
      );
    });
  };

  return {
    handleFilterByMockup,
    handleFilterByStructure,
    handleFilterByStatusOfRevision,
    handleFilterBySearchInput
  };
};
